import React, { useState } from "react";
// reactstrap components
import {
    Container,
} from "reactstrap";
import { Route, Redirect } from 'react-router-dom';

import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

//function TelePage2() {
const VDOCall = (props) => {

    var moment = require('moment');
    require('moment/locale/th');

    const [clientHeight, setClientHeight] = useState('');
    const [tokSession, setSession] = useState('');
    const [tokToken, setToken] = useState('');
    const [lineTrangskin, setLineTrangskin] = useState("");

    const teleID = (props.match.params.teleID !== undefined) ? props.match.params.teleID : null;

    const divStyle = {
        width: '100%',
        height: window.innerHeight,
        background: 'black',
        backgroundPosition: 'center',
        backgroundSize: 'auto 76%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDcxIDQ2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIwIiB4Mj0iMCIgeTE9IjAiIHkyPSIxIj48c3RvcCBvZmZzZXQ9IjY2LjY2JSIgc3RvcC1jb2xvcj0iI2ZmZiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIwIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBmaWxsPSJ1cmwoI2EpIiBkPSJNNzkgMzA4YzE0LjI1LTYuNSA1NC4yNS0xOS43NSA3MS0yOSA5LTMuMjUgMjUtMjEgMjUtMjFzMy43NS0xMyAzLTIyYy0xLjc1LTYuNzUtMTUtNDMtMTUtNDMtMi41IDMtNC43NDEgMy4yNTktNyAxLTMuMjUtNy41LTIwLjUtNDQuNS0xNi01NyAxLjI1LTcuNSAxMC02IDEwLTYtMTEuMjUtMzMuNzUtOC02Ny04LTY3cy4wNzMtNy4zNDYgNi0xNWMtMy40OC42MzctOSA0LTkgNCAyLjU2My0xMS43MjcgMTUtMjEgMTUtMjEgLjE0OC0uMzEyLTEuMzIxLTEuNDU0LTEwIDEgMS41LTIuNzggMTYuNjc1LTguNjU0IDMwLTExIDMuNzg3LTkuMzYxIDEyLjc4Mi0xNy4zOTggMjItMjItMi4zNjUgMy4xMzMtMyA2LTMgNnMxNS42NDctOC4wODggNDEtNmMtMTkuNzUgMi0yNCA2LTI0IDZzNzQuNS0xMC43NSAxMDQgMzdjNy41IDkuNSAyNC43NSA1NS43NSAxMCA4OSAzLjc1LTEuNSA0LjUtNC41IDkgMSAuMjUgMTQuNzUtMTEuNSA2My0xOSA2Mi0yLjc1IDEtNC0zLTQtMy0xMC43NSAyOS41LTE0IDM4LTE0IDM4LTIgNC4yNS0zLjc1IDE4LjUtMSAyMiAxLjI1IDQuNSAyMyAyMyAyMyAyM2wxMjcgNTNjMzcgMzUgMjMgMTM1IDIzIDEzNUwwIDQ2NHMtMy05Ni43NSAxNC0xMjBjNS4yNS02LjI1IDIxLjc1LTE5Ljc1IDY1LTM2eiIvPjwvc3ZnPg==)',

    };

    const channelId = '1654063801';
    const channelSecret = 'd420791098811eb59b8f98106929e9df';
    /*
    const liff = window.liff;
    liff.init({
        liffId: '1654063801-8MeEb6XR'
    })
        .then(() => {

            console.log('line login')
            if (liff.isLoggedIn()) {
                
                liff.getProfile().then(function (profile) {
                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                alert(profile.userId)
                                setLineTrangskin(profile.userId);
                            },
                            error => {
                                console.log(error);
                            }
                        );
                }).catch(function (error) {
                    window.alert('Error getting profile: ' + error);
                });
                
            }
            else {
                liff.login();
            }
        })
        .catch((err) => {

        });
*/

    React.useEffect(() => {

        setClientHeight('\'' + window.innerHeight + 'px\'');
        
        console.log('use effect')
        //fetch('/api/v1/mytele/'+ teleID, {
        fetch('/api/v1/tele/session/' + teleID, {
            method: 'GET',
            //headers: authHeader()
        })
        .then(handleResponse)
            //.then(response => response.json())
        .then(
            (result) => {
                setSession(result.tokSession)
                setToken(result.tokToken)
            },
            (error) => {
                alert(error);
            }
        );
        
        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };

    },[]);


    const handleSubmit = (evt) => {
        evt.preventDefault();

        
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
       
    }
    /*
    //authenticationService.logout();
    const currentUser = authenticationService.currentUserValue;
    //console.log(currentUser);

    //check login
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login',  }} />
    }*/
    /*state: { from: props.location }*/
    const onSubmit = values => {
      
    };

    return (
        <>
           
        </>
    );
}

export default VDOCall;
